/* eslint-disable max-len */
import { useEffect } from "react";

import { ReactComponent as LoaderIcon } from "../../Images/static/icons/220822_KALO_Loading_Animation_onload.svg";

import loaderAnimation from "../../utils/LoaderAnimation";

export function CalculationLoader() {
  useEffect(() => {
    jQuery("body").addClass("overflow-hidden");

    loaderAnimation();

    setTimeout(() => {
      jQuery(".calculated-price-loader").fadeOut({
        duration: 1000,
        complete() {
          jQuery("body").removeClass("overflow-hidden");
        },
      });
    }, 5000);
  }, []);

  return (
    <div className="calculated-price-loader frame frame-background-tertiary">
      <div className="frame-container frame-container-default">
        <div className="frame-inner frame-inner-space-before-medium frame-inner-space-after-medium">
          <div className="calculated-price-loader-content">
            <header className="frame-header frame-header-h2 frame-header-space-none">
              <h4 className="element-header text-center">
                <div>
                  <h4 className="element-header text-center">
                    Unsere Prognose für Ihre <br />
                    <span className="text-primary">
                      CO<sub>2</sub>-Kostenaufteilung wird berechnet.
                    </span>
                  </h4>
                </div>
              </h4>
            </header>

            <div className="calculated-price-loader-icon">
              <LoaderIcon />
            </div>

            <div className="calculated-price-loader-list">
              Dies kann einige Sekunden in Anspruch nehmen.
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
